import { scrollToPageTarget } from './scrollToPageTarget';

export function scrollToKarmaBarometer() {
  scrollToPageTarget(document.getElementById('karma-barometer'));
}
